import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import util from 'Utils/commonUtil';
import Anchor from 'Components/common/Anchor';
import Input from 'Components/common/Input';
import {QUESTION_TYPE, TASK_STATUS, TAB_FLAG} from 'Utils/constant';

import {T} from 'Actions/translate';
import {Checkbox, Radio} from '@material-ui/core';

class SelectChoice extends React.Component {
    animationTime = 300;
    handleOpenTimer = null;
    state = {
        opened: false,
        value: '',
        loading: false,
        uploadImageDialogOpened: false,
    };

    componentWillMount() {
        this.optionGroup = React.createRef();
    }

    numberToLetter = (numbers) => {
        const numberArray = Array.isArray(numbers) ? numbers : [numbers];
        return numberArray
            .sort((a, b) => a - b) // 升序排序
            .map((num) => String.fromCharCode(64 + num)); // 将数字转换为大写字母
    };

    uploadImageHandle = (index, sbuOptionIndex) => {
        this.setState({
            uploadImageDialogOpened: true,
        });
        console.log('index, sbuOptionIndex', index, sbuOptionIndex);
    };

    dialogDidClose = (dialog) =>
        this.state[dialog] && this.setState({[dialog]: false});

    chooseImage = (item) =>
        this.refs['inputFile'] && this.refs['inputFile'].click();

    selectedImage = (ev) => {
        if (!ev.target.files && !ev.target.files[0]) return;
        if (!/^image\//.test(ev.target.files[0].type)) {
            return this.props.openNotification(
                T('notification_please_select_picture'),
                'danger',
            );
        }
        const reader = new FileReader();
        const file = ev.target.files[0];

        reader.onload = (ev) => {
            this.setState({chooseImage: {file, url: ev.target.result}});
        };

        reader.readAsDataURL(file);
    };

    openOptionImageHandle = (index, sbuOptionIndex) => {
        console.log(
            'uploadOptionImageHandle index====================',
            index,
            sbuOptionIndex,
        );
        this.setState({
            currentQuestionIndex: index,
            currentOptionIndex: sbuOptionIndex,
            uploadImageDialogOpened: true,
        });
        this.props.openOptionImageHandle(index, sbuOptionIndex);
    };

    uploadConfirmHandle = () => {
        const {currentQuestionIndex, currentOptionIndex} = this.state;

        this.props.uploadOptionConfirmHandle(
            currentQuestionIndex,
            currentOptionIndex,
        );
    };

    renderOtherOperation = (index, optionItem, optionObj, sbuOptionIndex) => {
        const {tabFlag, taskStatus} = this.props;

        return (
            <div
                className={`${
                    optionItem.questionsOptions.length > 0 ? '' : 'other-set '
                } other-operation`}
                key={sbuOptionIndex}>
                <div className="option-first-row">
                    {optionObj && optionObj.allowFill ? (
                        <Input
                            placeholder={T('请输入...')}
                            type="text"
                            title={
                                'optionContent-' + index + '-' + sbuOptionIndex
                            }
                            onChange={this.handleOptionInputChange}
                            value={optionObj && optionObj.inputText}
                            required="false"
                            disabled={util.isDisabledQuestion(
                                tabFlag,
                                taskStatus,
                            )}
                        />
                    ) : null}
                    {optionObj &&
                    optionObj.allowUpload &&
                    (tabFlag === TAB_FLAG.TO_BE_COMPLETED ||
                        (tabFlag === TAB_FLAG.FOLLOW_UP &&
                            taskStatus === TASK_STATUS.PROGRESS)) ? (
                        <Anchor
                            className="upload-other-file"
                            onClickOfSingleTap={() =>
                                this.openOptionImageHandle(
                                    index,
                                    sbuOptionIndex,
                                )
                            }>
                            {T('task_details_upload_image')}
                        </Anchor>
                    ) : null}
                </div>
                <div className="upload-file">
                    {optionObj &&
                    this.getFileUrl(index, sbuOptionIndex, optionItem) ? (
                        <div className="show-file-name">
                            <a
                                className="show-file-name"
                                href={`${this.getFileUrl(
                                    index,
                                    sbuOptionIndex,
                                    optionItem,
                                )}`}>
                                {optionObj.fileName}
                            </a>
                        </div>
                    ) : (
                        <div className="show-file-name">
                            {optionObj.fileName}
                        </div>
                    )}
                    {optionObj &&
                    optionObj.fileName &&
                    (tabFlag === TAB_FLAG.TO_BE_COMPLETED ||
                        (tabFlag === TAB_FLAG.FOLLOW_UP &&
                            taskStatus === TASK_STATUS.PROGRESS)) ? (
                        <span
                            class="delete-btn"
                            onClick={() =>
                                this.deleteUploadFile(index, sbuOptionIndex)
                            }>
                            {T('lto_purchase_upload_file_delete')}
                        </span>
                    ) : null}
                </div>
            </div>
        );
    };

    handleGapFillingChange = (title, value) => {
        // console.log("handleGapFillingChange", title, value);
        this.props.handleGapFillingChange(title, value);
    };

    handleOptionInputChange = (title, value) => {
        console.log('handleOptionInputChange', title, value);
        this.props.handleOptionInputChange(title, value);
    };

    deleteUploadFile = (index, optionIndex) => {
        this.props.deleteUploadFileHandle(index, optionIndex);
    };

    getFileUrl = (index, optionIndex, optionItem) => {
        let fileUrl = '';
        let optionId = '';
        optionItem &&
            optionItem.questionsOptions &&
            optionItem.questionsOptions.length > 0 &&
            optionItem.questionsOptions.map((optionItem, opIndex) => {
                if (opIndex === optionIndex) {
                    fileUrl = optionItem.fileFullUrl;
                    optionId = optionItem.id;
                }
            });
        if (!fileUrl || (fileUrl && fileUrl.indexOf('https://') === -1)) {
            return false;
        }
        return fileUrl;
    };
    isAFlag = (questionsOptions) => {
        console.log('renderGapFilling questionsOptions', questionsOptions);
        let aFlag = false;
        if (
            questionsOptions[0].fileFullUrl &&
            questionsOptions[0].fileFullUrl.indexOf('https://') !== -1
        ) {
            aFlag = true;
        } else if (
            questionsOptions[0].fileFullUrl &&
            questionsOptions[0].fileFullUrl.indexOf('https://') === -1
        ) {
            aFlag = false;
        }
        return aFlag;
    };
    renderGapFilling = (index, optionItem, optionObj, sbuOptionIndex) => {
        const {tabFlag, taskStatus} = this.props;
        let questionsOptions = optionItem.questionsOptions;
        return optionItem.questionType &&
            optionItem.questionType === QUESTION_TYPE.GQP_FILLING ? (
            <div
                className={`${
                    questionsOptions.length > 0 ? '' : 'other-set '
                } other-operation`}>
                <div className="option-first-row">
                    <Input
                        placeholder={T('请输入...')}
                        type="text"
                        title={'gapFillingInput-' + index}
                        onChange={this.handleGapFillingChange}
                        value={questionsOptions[0].inputText}
                        required="false"
                        disabled={util.isDisabledQuestion(tabFlag, taskStatus)}
                    />
                    {questionsOptions[0].allowUpload &&
                    (tabFlag === TAB_FLAG.TO_BE_COMPLETED ||
                        (tabFlag === TAB_FLAG.FOLLOW_UP &&
                            taskStatus === TASK_STATUS.PROGRESS)) ? (
                        <Anchor
                            className="upload-other-file"
                            onClickOfSingleTap={() =>
                                this.openOptionImageHandle(index, 0)
                            }>
                            {T('task_details_upload_image')}
                        </Anchor>
                    ) : null}
                </div>
                <div className="upload-file">
                    {!this.isAFlag(questionsOptions) ? (
                        <div className="show-file-name">
                            {questionsOptions[0].fileName}
                        </div>
                    ) : (
                        <a
                            className="show-file-name"
                            href={`${
                                this.isAFlag(questionsOptions) &&
                                questionsOptions[0].fileFullUrl
                            }`}>
                            {questionsOptions[0].fileName}
                        </a>
                    )}
                    {questionsOptions[0].fileName &&
                    (tabFlag === TAB_FLAG.TO_BE_COMPLETED ||
                        (tabFlag === TAB_FLAG.FOLLOW_UP &&
                            taskStatus === TASK_STATUS.PROGRESS)) ? (
                        <span
                            class="delete-btn"
                            onClick={() => this.deleteUploadFile(index, 0)}>
                            {T('lto_purchase_upload_file_delete')}
                        </span>
                    ) : null}
                </div>
            </div>
        ) : null;
    };

    handleChangeSelect = (index, optionIndex, checked) => {
        console.log(
            'handleChangeSelect index, optionIndex, checked',
            index,
            optionIndex,
            checked,
        );
        this.props.handleChangeSelect(index, optionIndex, checked);
    };

    handleChangeRadioSelect = (index, optionIndex, checked) => {
        console.log(
            'handleChangeRadioSelect index, optionIndex, checked',
            index,
            optionIndex,
            checked,
        );
        this.props.handleChangeRadioSelect(index, optionIndex, checked);
    };

    showQuestionType = (optionItem) => {
        let questionTypeLabel = '';

        if (optionItem.questionType === QUESTION_TYPE.MULTIPLE) {
            questionTypeLabel = T('task_details_multiple');
        } else if (optionItem.questionType === QUESTION_TYPE.SINGLE) {
            questionTypeLabel = T('task_details_single');
        } else if (optionItem.questionType === QUESTION_TYPE.GQP_FILLING) {
            questionTypeLabel = T('task_details_gap_filling');
        }

        return questionTypeLabel;
    };

    render() {
        const {value} = this.state;
        const {options, index, optionItem, tabFlag, taskStatus} = this.props;
        const {icon} = options;
        console.log('tabFlag', tabFlag);
        console.log('taskStatus', taskStatus);
        // console.log('optionItem.questionsOptions', optionItem.questionsOptions);
        return (
            <div className="select-choice" key={index}>
                <label>
                    {optionItem.isRequired ? (
                        <span className="required-question">*</span>
                    ) : null}
                    {optionItem.serialNumber}.{optionItem.question}
                    {optionItem && optionItem.questionType
                        ? this.showQuestionType(optionItem)
                        : null}
                </label>

                {optionItem.questionType &&
                    optionItem.questionType == QUESTION_TYPE.MULTIPLE &&
                    optionItem.questionsOptions.map(
                        (optionObj, optionIndex) => (
                            <div key={optionIndex}>
                                <div className="sub-choice">
                                    {optionItem.questionType ===
                                        QUESTION_TYPE.MULTIPLE && (
                                        <Checkbox
                                            checked={optionObj.checked}
                                            onChange={() =>
                                                this.handleChangeSelect(
                                                    index,
                                                    optionIndex,
                                                    optionObj.checked,
                                                )
                                            }
                                            value={optionIndex}
                                            // disabled={util.isDisabledQuestion(
                                            //     tabFlag, taskStatus
                                            // )}
                                            disabled={
                                                tabFlag ===
                                                    TAB_FLAG.ALL_COMPLETED ||
                                                (tabFlag ===
                                                    TAB_FLAG.FOLLOW_UP &&
                                                    taskStatus ===
                                                        TASK_STATUS.SUBMITTED)
                                                    ? true
                                                    : false
                                            }
                                            className={'checkbox-button'}
                                        />
                                    )}
                                    <label>{optionObj.optionText}</label>
                                </div>
                                {typeof optionObj !== 'undefined'
                                    ? this.renderOtherOperation(
                                          index,
                                          optionItem,
                                          optionObj,
                                          optionIndex,
                                      )
                                    : null}
                            </div>
                        ),
                    )}
                {optionItem.questionType &&
                    optionItem.questionType === QUESTION_TYPE.SINGLE &&
                    optionItem.questionsOptions.map(
                        (optionObj, optionIndex) => (
                            <div key={optionIndex}>
                                <div className="sub-choice">
                                    {optionItem.questionType ===
                                        QUESTION_TYPE.SINGLE && (
                                        <Radio
                                            checked={optionObj.checked}
                                            onChange={() =>
                                                this.handleChangeRadioSelect(
                                                    index,
                                                    optionIndex,
                                                    optionObj.checked,
                                                )
                                            }
                                            value={optionObj.checked}
                                            className={'radio-button'}
                                            disabled={util.isDisabledQuestion(
                                                tabFlag,
                                                taskStatus,
                                            )}
                                        />
                                    )}
                                    <label>{optionObj.optionText}</label>
                                </div>
                                {typeof optionObj !== 'undefined'
                                    ? this.renderOtherOperation(
                                          index,
                                          optionItem,
                                          optionObj,
                                          optionIndex,
                                      )
                                    : null}
                            </div>
                        ),
                    )}
                {optionItem.questionType &&
                    optionItem.questionType === QUESTION_TYPE.GQP_FILLING &&
                    this.renderGapFilling(index, optionItem)}
            </div>
        );
    }
}

SelectChoice.defaultProps = {
    mode: 'select',
    data: [],
    className: '',
    options: {
        icon: {
            show: true,
        },
    },
};

export default SelectChoice;
